import { PensionCalculatorResponse } from "../types";

const filterData = (props: { data: PensionCalculatorResponse[] }) => {
  const header = props.data?.filter((element) => element.name === "HEADER")[0]
    ?.value;

  const selectLabel = props.data?.filter(
    (element) => element.name === "SELECT_LABEL",
  )[0]?.value;

  const inputLabel = props.data?.filter(
    (element) => element.name === "INPUT_LABEL",
  )[0]?.value;

  const inputLabelError = props.data?.filter(
    (element) => element.name === "INPUT_LABEL_ERROR",
  )[0]?.value;

  const buttonCalculate = props.data?.filter(
    (element) => element.name === "BUTTON_CALCULATE",
  )[0]?.value;

  const midParagraph = props.data?.filter(
    (element) => element.name === "MID_PARAGRAPH",
  )[0]?.value;

  const averageMonthlySalary = props.data?.filter(
    (element) => element.name === "AVERAGE_MONTHLY_SALARY",
  )[0]?.value;

  const yearlySalary = props.data?.filter(
    (element) => element.name === "YEARLY_SALARY",
  )[0]?.value;

  const percentageOfYearlySalaryUp = props.data?.filter(
    (element) => element.name === "PERCENTAGE_OF_YEARLY_SALARY_UP",
  )[0]?.value;

  const percentageOfYearlySalaryOver = props.data?.filter(
    (element) => element.name === "PERCENTAGE_OF_YEARLY_SALARY_OVER",
  )[0]?.value;

  const yearlyPremium = props.data?.filter(
    (element) => element.name === "YEARLY_PREMIUM",
  )[0]?.value;

  const endParagraph = props.data?.filter(
    (element) => element.name === "END_PARAGRAPH",
  )[0]?.value;

  const privateEmployeeParagraph = props.data?.filter(
    (element) => element.name === "PRIVATE_EMPLOYEE_PARAGRAPH",
  )[0]?.value;

  const stateEmployeeParagraph = props.data?.filter(
    (element) => element.name === "STATE_EMPLOYEE_PARAGRAPH",
  )[0]?.value;

  const employeesWithinTheCooperationParagraph = props.data?.filter(
    (element) => element.name === "EMPLOYEES_WITHIN_THE_COOPERATION_PARAGRAPH",
  )[0]?.value;

  const employeesWithinTheCooperationKTPParagraph = props.data?.filter(
    (element) =>
      element.name === "EMPLOYEES_WITHIN_THE_COOPERATION_PARAGRAPH_KTP",
  )[0]?.value;

  const municipalityAndCountyCouncilParagraph = props.data?.filter(
    (element) => element.name === "MUNICIPALITY_AND_COUNTY_COUNCIL_PARAGRAPH",
  )[0]?.value;

  const municipalityAndCountyCouncilParagraphAkapKr = props.data?.filter(
    (element) =>
      element.name === "MUNICIPALITY_AND_COUNTY_COUNCIL_PARAGRAPH_AKAP_KR",
  )[0]?.value;

  const municipalityAndCountyCouncilParagraphKapKl = props.data?.filter(
    (element) =>
      element.name === "MUNICIPALITY_AND_COUNTY_COUNCIL_PARAGRAPH_KAP_KL",
  )[0]?.value;

  const percentageOfYearlySalaryOverAkapKr = props.data?.filter(
    (element) => element.name === "PERCENTAGE_OF_YEARLY_SALARY_OVER_AKAP_KR",
  )[0]?.value;

  const percentageOfYearlySalaryUpAkapKr = props.data?.filter(
    (element) => element.name === "PERCENTAGE_OF_YEARLY_SALARY_UP_AKAP_KR",
  )[0]?.value;

  const percentageOfYearlySalaryOverKTP = props.data?.filter(
    (element) => element.name === "PERCENTAGE_OF_YEARLY_SALARY_OVER_KTP",
  )[0]?.value;

  const percentageOfYearlySalaryUpKTP = props.data?.filter(
    (element) => element.name === "PERCENTAGE_OF_YEARLY_SALARY_UP_KTP",
  )[0]?.value;

  const salaryLimit = props.data?.filter(
    (element) => element.name === "SALARY_LIMIT",
  )[0]?.value;

  const salaryCapKapKl = props.data?.filter(
    (element) => element.name === "SALARY_CAP_KAP_KL",
  )[0]?.value;

  const fixedSumForMaxPremium = props.data?.filter(
    (element) => element.name === "FIXED_SUM_FOR_MAX_PREMIUM",
  )[0]?.value;

  return {
    header: header,
    selectLabel: selectLabel,
    inputLabel: inputLabel,
    inputLabelError: inputLabelError,
    buttonCalculate: buttonCalculate,
    midParagraph: midParagraph,
    averageMonthlySalary: averageMonthlySalary,
    yearlySalary: yearlySalary,
    percentageOfYearlySalaryUp: percentageOfYearlySalaryUp,
    percentageOfYearlySalaryOver: percentageOfYearlySalaryOver,
    yearlyPremium: yearlyPremium,
    endParagraph: endParagraph,
    privateEmployeeParagraph: privateEmployeeParagraph,
    stateEmployeeParagraph: stateEmployeeParagraph,
    employeesWithinTheCooperationParagraph:
      employeesWithinTheCooperationParagraph,
    employeesWithinTheCooperationKTPParagraph:
      employeesWithinTheCooperationKTPParagraph,
    municipalityAndCountyCouncilParagraph:
      municipalityAndCountyCouncilParagraph,
    municipalityAndCountyCouncilParagraphAkapKr:
      municipalityAndCountyCouncilParagraphAkapKr,
    municipalityAndCountyCouncilParagraphKapKl:
      municipalityAndCountyCouncilParagraphKapKl,
    percentageOfYearlySalaryOverAkapKr: percentageOfYearlySalaryOverAkapKr,
    percentageOfYearlySalaryUpAkapKr: percentageOfYearlySalaryUpAkapKr,
    percentageOfYearlySalaryOverKTP: percentageOfYearlySalaryOverKTP,
    percentageOfYearlySalaryUpKTP: percentageOfYearlySalaryUpKTP,
    salaryLimit: salaryLimit,
    salaryCapKapKl: salaryCapKapKl,
    fixedSumForMaxPremium: fixedSumForMaxPremium,
  };
};
export default filterData;
